import React from "react";
import { Box, Button } from "@mui/material";
import { styled } from "@mui/material/styles";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

const SplitButtonContainer = styled(Box)({
  display: "inline-flex",
  alignItems: "center",
  width: "fit-content",
  maxWidth: "100%",
  overflow: "hidden",
  borderRadius: "8px",
  border: "1px solid #DBE8FF",
  backgroundColor: "#0057FF",
  height: "40px",
  boxSizing: "border-box",
});

const MainButton = styled(Button)({
  borderRadius: 0,
  color: "#FCFCFC",
  textTransform: "none",
  padding: "0 16px",
  minWidth: "unset",
  height: "100%",
  whiteSpace: "nowrap",
  flexShrink: 0,

  "&:hover": {
    backgroundColor: "#00308C",
  },
});

const Divider = styled(Box)({
  width: "1px",
  height: "100%",
  backgroundColor: "#DBE8FF",
});

const DropdownButton = styled(Button)({
  borderRadius: 0,
  minWidth: "44px",
  width: "44px",
  color: "#FCFCFC",
  padding: 0,
  height: "100%",
  flexShrink: 0,

  "&:hover": {
    backgroundColor: "#00308C",
  },
});

const CustomSplitButton = React.forwardRef(
  (
    {
      label,
      startIcon,
      onMainClick,
      onDropdownClick,
      disabled = false,
      dropdownDisabled = false,
      ...props
    },
    ref
  ) => {
    return (
      <SplitButtonContainer>
        <MainButton
          startIcon={startIcon}
          onClick={onMainClick}
          disabled={disabled}
          {...props}
        >
          {label}
        </MainButton>

        <DropdownButton
          ref={ref}
          onClick={onDropdownClick}
          disabled={disabled || dropdownDisabled}
        >
          <ArrowDropDownIcon />
        </DropdownButton>
      </SplitButtonContainer>
    );
  }
);

CustomSplitButton.displayName = "CustomSplitButton";

export default CustomSplitButton;